import React from 'react';
import { ISelectCoverProps } from './SelectCover.types';
import {
  IOptionList,
  IOptionElement,
  Options as FlowCompOptions,
  OptionElementTextAlign,
  OptionElementType,
  OptionalLayout,
  useFlowController,
  useFlowData,
  FlowTypes,
} from '@adaptis/flow-components';

import './SelectCover.scss';

export default function SelectCover(props: ISelectCoverProps) {
  const { getData } = useFlowData();
  const optionSelected = getData(props.dataField ?? '');
  const petType = getData('petType');

  const MostPopularImage: IOptionElement = {
    elementType: OptionElementType.Image,
    src:
      petType === 'dog'
        ? props.topCover.imageUrlDog
        : props.topCover.imageUrlCat,
  };

  const MostPopularButtonTag: IOptionElement = {
    elementType: OptionElementType.Text,
    text: props.topCover.btnTagText,
    textAlign: OptionElementTextAlign.Center,
  };

  const MostPopularButton: IOptionElement = {
    elementType: OptionElementType.Button,
    buttonStyle: 'filled',
    text: props.topCover.btnText,
  };

  const MostPopularOptionElements: Array<IOptionElement> = [
    MostPopularImage,
    MostPopularButtonTag,
    MostPopularButton,
  ];

  const MostPopularOptionList: IOptionList = {
    dataValue: props.topCover.value,
    optionElements: MostPopularOptionElements,
  };

  const DIYImage: IOptionElement = {
    elementType: OptionElementType.Image,
    src:
      petType === 'dog'
        ? props.buildMyOwn.imageUrlDog
        : props.buildMyOwn.imageUrlCat,
  };

  const DYIButtonTag: IOptionElement = {
    elementType: OptionElementType.Text,
    text: props.buildMyOwn.btnTagText,
    textAlign: OptionElementTextAlign.Center,
  };

  const DIYButton: IOptionElement = {
    elementType: OptionElementType.Button,
    buttonStyle: 'outline',
    text: props.buildMyOwn.btnText,
  };
  const DYIOptionElements: Array<IOptionElement> = [
    DIYImage,
    DYIButtonTag,
    DIYButton,
  ];

  const DYIOptionList: IOptionList = {
    dataValue: props.buildMyOwn.value,
    optionElements: DYIOptionElements,
  };

  const optionList: Array<IOptionList> = [MostPopularOptionList, DYIOptionList];

  function heading(): string {
    if (optionSelected == props.buildMyOwn.value) {
      return props.buildMyOwn.headingText;
    } else {
      return props.topCover.headingText;
    }
  }

  function paragraph(): string {
    if (optionSelected == props.buildMyOwn.value) {
      return props.buildMyOwn.descText;
    } else {
      return props.topCover.descText;
    }
  }

  return (
    <div data-testid='SelectCover' className='flc_select-cover'>
      <FlowCompOptions
        stepSlug={props.stepSlug}
        dataField={props.dataField}
        layout={OptionalLayout.Stacked}
        optionList={optionList}
      />
      <div>
        <h2>{heading()}</h2>
        <div>{paragraph()}</div>
      </div>
    </div>
  );
}
